import { titleCaseHeadline } from "../utils/titleCase";
import { useState } from "react";
import { Link } from "./CanonicalLink";
import { ArrowUpRight, Loader2 } from "lucide-react";
import { getGambiaNewsList } from "../data/stories";
import Reveal from "./Reveal";

const PAGE = 3;

export const GambianNews = () => {
  const [count, setCount] = useState(6);
  const [loading, setLoading] = useState(false);
  const newsList = getGambiaNewsList();
  const visible = newsList.slice(0, count);
  const done = count >= newsList.length;

  const loadMore = () => {
    setLoading(true);
    setTimeout(() => {
      setCount((c) => Math.min(c + PAGE, newsList.length));
      setLoading(false);
    }, 450);
  };

  return (
    <section
      id="gambia-news"
      data-testid="gambia-news-section"
      className="bg-[var(--bg)] mt-16"
    >
      <div className="mx-auto max-w-[1440px] px-4 sm:px-6 pb-14 sm:pb-16">
        <Reveal>
          <div className="flex flex-wrap items-center justify-between gap-4 rounded-[4px] overflow-hidden border-t-[3px] border-[#cf0a0a] bg-[var(--bg-soft)] px-5 sm:px-7 py-5">
            <h2 className="font-display text-3xl font-semibold">Gambia News</h2>
            <Link
              to="/category/gambia-news"
              data-testid="gambia-news-more"
              className="flex items-center gap-1 text-[10px] font-extrabold uppercase tracking-[0.2em] text-[var(--accent)] hover:gap-2 transition-all duration-300"
            >
              All Gambia news <ArrowUpRight size={13} />
            </Link>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {visible.map((article, i) => (
            <Reveal key={article.id} delay={(i % 3) * 0.07} className="h-full">
              <article data-testid={`gambia-news-card-${article.id}`} className="group h-full">
                <Link to={`/${article.id}`} className="block h-full">
                  <div className="img-frame overflow-hidden aspect-[16/10] bg-[var(--card-muted)]">
                    <img
                      src={article.img}
                      alt={article.imgAlt}
                      loading="lazy"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <p className="mt-3.5 flex items-center justify-between gap-3">
                    <span className="text-[10px] font-extrabold uppercase tracking-[0.2em] text-[var(--accent)]">
                      {article.kicker}
                    </span>
                    <span className="text-[11px] text-[var(--faint)] whitespace-nowrap">
                      {article.date}
                    </span>
                  </p>
                  <h3 className="mt-1.5 font-display text-lg leading-snug font-semibold group-hover:text-[var(--accent)] transition-colors duration-300">
                    {titleCaseHeadline(article.title)}
                  </h3>
                  <p className="mt-2 text-[13px] leading-relaxed text-[var(--muted)] line-clamp-2">
                    {article.excerpt}
                  </p>
                </Link>
              </article>
            </Reveal>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center gap-3">
          {!done ? (
            <button
              onClick={loadMore}
              disabled={loading}
              data-testid="gambia-news-load-more"
              className="inline-flex items-center gap-2 rounded-[5px] bg-[#cf0a0a] text-white border-2 border-[#cf0a0a] px-8 py-3 text-[12px] font-bold uppercase tracking-[0.2em] hover:bg-black hover:border-black hover:text-white disabled:opacity-60 transition-colors"
            >
              {loading ? (
                <>
                  <Loader2 size={14} className="animate-spin" /> Loading…
                </>
              ) : (
                "Load more stories"
              )}
            </button>
          ) : (
            <p className="text-[11px] uppercase tracking-[0.2em] text-[var(--faint)]" data-testid="gambia-news-caught-up">
              You’re all caught up
            </p>
          )}
          <p className="text-[10px] text-[var(--faint)]" data-testid="gambia-news-count">
            Showing {visible.length} of {newsList.length} stories
          </p>
        </div>
      </div>
    </section>
  );
};

export default GambianNews;
